import { Component, Input, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { PessoaSituacao, PessoaSituacaoLabels } from '@tivic-team/manager-ts/dist/grl/enums/pessoa-situacao.enum'

@Component({
  selector: 'dropdown-sitaucao-cadastro',
  templateUrl: './dropdown-sitaucao-cadastro.component.html',
  styleUrls: ['./dropdown-sitaucao-cadastro.component.scss']
})
export class DropdownSituacaoCadastroComponent implements OnInit {

  situacoes

  @Input() formGroup: FormGroup;

  constructor() { }

  ngOnInit() {
    this.situacoes = PessoaSituacaoLabels
  }

}
